import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ComponentBase, T4TurboOrderService, T4ListItem, ApiService } from 't4core';

@Component({
  selector: 't4-group-filter',
  templateUrl: './t4-group-filter.component.html',
  styleUrls: ['./t4-group-filter.component.css']
})
export class T4GroupFilterComponent extends ComponentBase implements OnInit, OnDestroy {

  public locationGroups: T4ListItem[] = [];
  public filteredGroups: any[] = [];
  public rentalLocationGroup: number = 0;
  public searchText: string = '';
  @Output() rentalLocationGroupChanged = new EventEmitter<T4ListItem>();

  constructor(private orderSvc: T4TurboOrderService) {
    super();
  }

  public async ngOnInit() {
    this.Api.setSubContext("");
    await this.loadRentalLocationGroups();
  }

  private async loadRentalLocationGroups() {
    this.locationGroups = await this.orderSvc.GetT4GroupsWithinEntity();
    this.filteredGroups = this.locationGroups;
  }

  public filterGroups() {
    this.filteredGroups = this.locationGroups.filter(group => group.Name.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  public resetSearch(opened: boolean) {
    if (!opened) {
      this.searchText = '';
      this.filteredGroups = this.locationGroups;
    }
  }

  public async onGroupChange(value: number) {
    this.rentalLocationGroup = value;
    await this.emitRentalLocationGroup();
  }

  public async emitRentalLocationGroup() {
    if (this.rentalLocationGroup != 0) {
      var selectedGroup = this.locationGroups.filter(x => x.Id == this.rentalLocationGroup.toString());
      if (selectedGroup && selectedGroup.length > 0) {
        this.Api.setSubContext(selectedGroup[0].ContextId);
        this.rentalLocationGroupChanged.emit(selectedGroup[0]);
        return;
      }
    }

    this.Api.setSubContext("");
    this.rentalLocationGroupChanged.emit(null);
  }

  public async ngOnDestroy() {
    this.Api.setSubContext("");
  }
}
